// Eszköz-ár formázás — a lista, az export és az igény-sáv közös forrása (tiszta függvények, nincs JSX).

/** HUF-formázás a legacy `FormatterService::formatPrice` szerint: EGÉSZ összeg → tizedes nélkül, TÖRT → 2 tizedes
 *  (vessző tizedes-jel + szóköz ezres-tagolás), „ Ft" utótag. Pl. 551173 → „551 173 Ft"; 699989.71 → „699 989,71 Ft". */
export function fmtHuf(amount: number): string {
  const whole = Number.isInteger(amount);
  return `${amount.toLocaleString('hu-HU', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  })} Ft`;
}

/** ÁFA-kulcs + „%" — max. 2 tizedes, de a felesleges záró-nullák levágva (27.00 → 27; 14.50 → 14.5; 18.94 marad). */
export function fmtPercent(rate: number): string {
  return `${Number(rate.toFixed(2))}%`;
}

/** Az ár három értéke: a bruttó SZÁMÍTOTT (nettó × (1 + áfa/100), 2 tizedesre kerekítve). Érvénytelen nettó → `null`. */
export function priceParts(
  netPrice: string | null,
  vatRate: string | null,
): { net: number; vatPct: number; gross: number } | null {
  const net = netPrice ? Number(netPrice) : NaN;
  if (Number.isNaN(net)) return null;
  const vat = vatRate ? Number(vatRate) : 0;
  const vatPct = Number.isNaN(vat) ? 0 : vat;
  return { net, vatPct, gross: Math.round(net * (1 + vatPct / 100) * 100) / 100 };
}
